/* eslint-disable class-methods-use-this */
import {
  post,
  get,
  put,
  _delete,
} from '@/lin/plugins/axios'

const _baseUri = 'plugin/xy/showcase/'

class Showcase {
  // constructor() {}

  // 类中的方法可以代表一个用户行为
  async addData(info) {
    const res = await post(_baseUri, info)
    return res
  }

  async getData(id) {
    const res = await get(`${_baseUri}${id}`)
    return res
  }

  async editData(id, info) {
    const res = await put(`${_baseUri}${id}`, info)
    return res
  }

  async updateDisplay(id, info) {
    const data = {
      display: info.display,
    }
    const res = await put(`${_baseUri}display/${id}/`, data)
    return res
  }

  async updateCounter(id, info) {
    const res = await put(`${_baseUri}counter/${id}`, info)
    return res
  }

  async delectData(id) {
    const res = await _delete(`${_baseUri}${id}`)
    return res
  }

  async getDatas(pageInfo) {
    const res = await get(_baseUri, pageInfo)
    return res
  }
}

export default new Showcase()
